import { render, staticRenderFns } from "./OrderManagementSystemPage.vue?vue&type=template&id=1c81fea0&scoped=true"
import script from "./OrderManagementSystemPage.vue?vue&type=script&lang=js"
export * from "./OrderManagementSystemPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81fea0",
  null
  
)

export default component.exports